import { MutableState } from '../State';
import type { ResurrectionReward } from './resurrection.schema';
import { hasResurrectionRewardToClaim } from './resurrection.getters';

/**
 * Set resurrection item timestamp
 */
export function setResurrectionReward(
  state: MutableState,
  item: ResurrectionReward,
  now: number,
): void {
  // Initialize resurrection object if not present
  if (!state.resurrection) {
    state.resurrection = {};
  }

  // Set the timestamp for the specified resurrection item
  state.resurrection[item] = now;
}

/**
 * Claim resurrection item if available
 */
export function claimResurrectionReward(
  state: MutableState,
  item: ResurrectionReward,
  now: number,
): boolean {
  // Check if the item can be claimed - return false if not
  if (!hasResurrectionRewardToClaim(state, item, now)) return false;

  // Remove the claimed item's timestamp
  delete state.resurrection?.[item];

  // Return true to indicate the item was successfully claimed
  return true;
}
